import React from "react";

export function H3({ className = "", ...props }) {
  return (
    <h3 className={`${className} mt-4 text-lg text-blue-800`} {...props} />
  );
}
